import { Offcanvas, Form, Row, Col, InputGroup, Button } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';

const FilterProjectsOffcanvas = ({ 
    show, 
    onHide,
    clientFilter,
    setClientFilter,
    projectFilter,
    setProjectFilter,
    assigneeFilter,
    setAssigneeFilter,
    dueDateRange,
    setDueDateRange,
    budgetRange,
    setBudgetRange,
    paymentFilter,
    setPaymentFilter,
    stageFilter,
    setStageFilter,
    projectOptions,
    assigneeOptions,
    clientOptions,
    paymentOptions,
    stageOptions
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Filter Projects</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form>
                    <Row className='gy-2'>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Client Name</Form.Label>
                                <Select
                                    value={clientFilter}
                                    onChange={setClientFilter}
                                    options={clientOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Project</Form.Label>
                                <Select
                                    value={projectFilter}
                                    onChange={setProjectFilter}
                                    options={projectOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Assignees</Form.Label>
                                <Select
                                    value={assigneeFilter}
                                    onChange={setAssigneeFilter}
                                    options={assigneeOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Start & End Date Range</Form.Label>
                                <InputGroup>
                                    <Flatpickr
                                        value={dueDateRange[0]}
                                        onChange={([date]) => setDueDateRange([date, dueDateRange[1]])}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            maxDate: dueDateRange[1] || 'today',
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                        }}
                                        placeholder="Start date"
                                    />
                                    <InputGroup.Text className="bg-light p-tag">to</InputGroup.Text>
                                    <Flatpickr
                                        value={dueDateRange[1]}
                                        onChange={([date]) => setDueDateRange([dueDateRange[0], date])}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            maxDate: 'today',
                                            minDate: dueDateRange[0],
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                        }}
                                        placeholder="End date"
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Budget Range</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        type="number"
                                        value={budgetRange[0] || ''}
                                        onChange={(e) => setBudgetRange([e.target.value ? Number(e.target.value) : null, budgetRange[1]])}
                                        placeholder="Min budget"
                                        min={0}
                                    />
                                    <InputGroup.Text className="bg-light">to</InputGroup.Text>
                                    <Form.Control
                                        type="number"
                                        value={budgetRange[1] || ''}
                                        onChange={(e) => setBudgetRange([budgetRange[0], e.target.value ? Number(e.target.value) : null])}
                                        placeholder="Max budget"
                                        min={budgetRange[0] || 0}
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Payment Status</Form.Label>
                                <Select
                                    value={paymentFilter}
                                    onChange={setPaymentFilter}
                                    options={paymentOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Stage</Form.Label>
                                <Select
                                    value={stageFilter}
                                    onChange={setStageFilter}
                                    options={stageOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 border-top">
                <div className="d-flex justify-content-between">
                    <Button variant="link" className='text-decoration-none' onClick={() => {
                        setClientFilter(null);
                        setProjectFilter(null);
                        setAssigneeFilter([]);
                        setDueDateRange([null, null]);
                        setBudgetRange([null, null]);
                        setPaymentFilter(null);
                        setStageFilter(null);
                    }}>
                        Reset
                    </Button>
                    <Button variant="primary" onClick={onHide}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

export default FilterProjectsOffcanvas;
